import React from 'react';

const Decor3: React.FC = () => {
  return (
    <g
      className="prefix__map-decor-3 prefix__map-decor"
      transform="translate(85 140)"
    >
      <defs>
        <linearGradient
          id="ae0dbbf9-b0af-4a31-946e-5234a0c47ae7"
          data-name="drag-109"
          x1="1255.9"
          y1="67.19"
          x2="1339.74"
          y2="67.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#005990" />
          <stop offset="0" stopColor="#00598f" />
          <stop offset="0.07" stopColor="#0c4e71" />
          <stop offset="0.14" stopColor="#13475f" />
          <stop offset="0.18" stopColor="#154558" />
          <stop offset="0.4" stopColor="#114151" />
          <stop offset="0.86" stopColor="#0f3f4f" />
        </linearGradient>
        <linearGradient
          id="ed1e1f9b-c26c-49bd-a531-344686d20627"
          x1="373.57"
          y1="154.56"
          x2="457.42"
          y2="154.56"
          xlinkHref="#ae0dbbf9-b0af-4a31-946e-5234a0c47ae7"
        />
        <linearGradient
          id="a4a1070f-2d1e-4afb-82d2-913a3b28768f"
          data-name="drag-28"
          x1="1349.43"
          y1="86.07"
          x2="1349.95"
          y2="151.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#f4cb76" />
          <stop offset="1" stopColor="#bf534f" />
        </linearGradient>
        <linearGradient
          id="b6eb3326-c09a-42e9-aae4-ca8574802b5c"
          x1="1345.24"
          y1="107.3"
          x2="1345.53"
          y2="143.28"
          xlinkHref="#a4a1070f-2d1e-4afb-82d2-913a3b28768f"
        />
        <linearGradient
          id="f02313d8-d10b-4b50-8a7b-ac484699db62"
          x1="1349.59"
          y1="116.01"
          x2="1348.33"
          y2="163.29"
          xlinkHref="#a4a1070f-2d1e-4afb-82d2-913a3b28768f"
        />
        <linearGradient
          id="bdf202e7-6d79-486b-9181-659313282056"
          data-name="drag-126"
          x1="1330.09"
          y1="196.21"
          x2="1330.69"
          y2="270.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00ac90" />
          <stop offset="0.09" stopColor="#009e87" />
          <stop offset="0.37" stopColor="#00746c" />
          <stop offset="0.63" stopColor="#005658" />
          <stop offset="0.84" stopColor="#00444c" />
          <stop offset="1" stopColor="#003d48" />
        </linearGradient>
        <linearGradient
          id="f4c3843d-6d7f-4382-8706-3bd69bb1e03b"
          x1="1325.32"
          y1="220.38"
          x2="1325.66"
          y2="261.35"
          xlinkHref="#bdf202e7-6d79-486b-9181-659313282056"
        />
        <linearGradient
          id="b8ef41a7-c67e-4bc7-b8fd-3f70a819078e"
          x1="1330.28"
          y1="230.3"
          x2="1328.84"
          y2="284.13"
          xlinkHref="#bdf202e7-6d79-486b-9181-659313282056"
        />
        <linearGradient
          id="b42ae52d-ce66-4aff-9c73-78f5c68831b8"
          x1="1364.69"
          y1="455.14"
          x2="1365.13"
          y2="510.28"
          xlinkHref="#a4a1070f-2d1e-4afb-82d2-913a3b28768f"
        />
        <linearGradient
          id="a70e248e-150a-495e-9c17-0d1962597894"
          x1="1361.14"
          y1="473.11"
          x2="1361.39"
          y2="503.58"
          xlinkHref="#a4a1070f-2d1e-4afb-82d2-913a3b28768f"
        />
        <linearGradient
          id="aa4ea4da-d765-4629-88cd-d401b1f1e978"
          x1="1364.83"
          y1="480.49"
          x2="1363.76"
          y2="520.53"
          xlinkHref="#a4a1070f-2d1e-4afb-82d2-913a3b28768f"
        />
        <linearGradient
          id="a9d81c9b-7588-41b7-932f-5c9366abb60d"
          data-name="drag-58"
          x1="1292.35"
          y1="225.8"
          x2="1292.8"
          y2="280.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#dd15ff" />
          <stop offset="1" stopColor="#5f3e56" />
        </linearGradient>
        <linearGradient
          id="b1d1cea7-3468-40a9-bfd3-91bda3f5e81d"
          x1="1288.81"
          y1="243.78"
          x2="1289.06"
          y2="274.25"
          xlinkHref="#a9d81c9b-7588-41b7-932f-5c9366abb60d"
        />
        <linearGradient
          id="e75b55c3-eec0-40da-a7f1-4077924a8954"
          x1="1292.5"
          y1="251.15"
          x2="1291.43"
          y2="291.19"
          xlinkHref="#a9d81c9b-7588-41b7-932f-5c9366abb60d"
        />
        <linearGradient
          id="b0b72e65-da67-4ceb-a0c3-b871a4e3573d"
          x1="1004.16"
          y1="202.83"
          x2="1004.74"
          y2="274.64"
          xlinkHref="#a9d81c9b-7588-41b7-932f-5c9366abb60d"
        />
        <linearGradient
          id="aa13e0ee-60a7-443e-a0ca-c2068fadecfc"
          x1="999.54"
          y1="226.24"
          x2="999.86"
          y2="265.91"
          xlinkHref="#a9d81c9b-7588-41b7-932f-5c9366abb60d"
        />
        <linearGradient
          id="bd5f5694-4663-4b04-b73e-a49d56b5b898"
          x1="1004.34"
          y1="235.85"
          x2="1002.95"
          y2="287.97"
          xlinkHref="#a9d81c9b-7588-41b7-932f-5c9366abb60d"
        />
        <linearGradient
          id="a26ae79a-558f-41fb-9669-c8c41f5a23ec"
          x1="432.28"
          y1="363.81"
          x2="485.6"
          y2="363.81"
          xlinkHref="#bdf202e7-6d79-486b-9181-659313282056"
        />
        <linearGradient
          id="b566dfc1-8b59-4950-8277-1984ff8192f3"
          x1="457.43"
          y1="305.76"
          x2="457.92"
          y2="365.74"
          xlinkHref="#bdf202e7-6d79-486b-9181-659313282056"
        />
        <linearGradient
          id="ff8f5b7d-504a-4de8-aee7-15a046f998fb"
          x1="453.58"
          y1="325.31"
          x2="453.85"
          y2="358.45"
          xlinkHref="#bdf202e7-6d79-486b-9181-659313282056"
        />
        <linearGradient
          id="f3ec731a-d00d-498a-ac8d-234942316d06"
          x1="457.59"
          y1="333.34"
          x2="456.43"
          y2="376.87"
          xlinkHref="#bdf202e7-6d79-486b-9181-659313282056"
        />
        <linearGradient
          id="bf3d277b-04a3-443c-a2db-085899d44712"
          x1="483.63"
          y1="378.33"
          x2="520.41"
          y2="378.33"
          xlinkHref="#a4a1070f-2d1e-4afb-82d2-913a3b28768f"
        />
        <linearGradient
          id="bfd24747-396b-4e44-99df-0ee44a0e5943"
          x1="500.98"
          y1="338.29"
          x2="501.31"
          y2="379.66"
          xlinkHref="#a4a1070f-2d1e-4afb-82d2-913a3b28768f"
        />
        <linearGradient
          id="a0bd59cc-cb4c-4b47-aee4-e19b83c7662a"
          x1="498.32"
          y1="351.78"
          x2="498.51"
          y2="374.63"
          xlinkHref="#a4a1070f-2d1e-4afb-82d2-913a3b28768f"
        />
        <linearGradient
          id="aa784408-2550-434a-99ff-d8cb131c265f"
          x1="501.09"
          y1="357.31"
          x2="500.29"
          y2="387.34"
          xlinkHref="#a4a1070f-2d1e-4afb-82d2-913a3b28768f"
        />
        <linearGradient
          id="b6be1f12-19da-4f17-b067-a4abf87206c9"
          x1="404.14"
          y1="388.52"
          x2="440.91"
          y2="388.52"
          xlinkHref="#a9d81c9b-7588-41b7-932f-5c9366abb60d"
        />
        <linearGradient
          id="b744fe62-4945-4b14-9c8d-ecdd72017ebe"
          x1="421.49"
          y1="348.49"
          x2="421.82"
          y2="389.85"
          xlinkHref="#a9d81c9b-7588-41b7-932f-5c9366abb60d"
        />
        <linearGradient
          id="abd842f3-19ec-4d33-9052-493b06e42c99"
          x1="418.83"
          y1="361.98"
          x2="419.01"
          y2="384.83"
          xlinkHref="#a9d81c9b-7588-41b7-932f-5c9366abb60d"
        />
        <linearGradient
          id="b8888181-df7a-48af-b71c-3cd19fa2bb19"
          x1="421.59"
          y1="367.51"
          x2="420.79"
          y2="397.53"
          xlinkHref="#a9d81c9b-7588-41b7-932f-5c9366abb60d"
        />
      </defs>
      {/* <g opacity="0.47">
        <path
          d="M1335.38,89.73a5.1,5.1,0,0,0,1.58-9.59c-4.38-2.19-10.15-3.12-15.19-1,15-6.41,22.6-14.24,12.82-21.36-7.83-5.69-19.93,14.95-22.78,14.95s1.42-8.54,7.83-16.37,5.69-14.23.71-16.37-13.52,1.42-15.66,23.49c0-3.56,1.43-25.62-4.27-23.49s-10,14.24-.71,27.05c-5.69,2.13-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.65,0,22.77,7.12,11.39-2.14,7.12-13.52-14.24-22.06-4.27,15,22.06,28.47,22.77C1296,95.35,1321.88,91.75,1335.38,89.73Z"
          fill="url(#ae0dbbf9-b0af-4a31-946e-5234a0c47ae7)"
        />
        <path
          d="M1326.77,87.81c.5-4-7.08-8.09-13.15-3,9.1-8.09,11.12-14.67,6.57-14.67s-14.66,8.6-16.68,8.6,4.46-3.94,9-9.5,2.12-9.87-1.42-11.39c-3.32-1.42-13.38,1.78-16,15a2.29,2.29,0,0,1-1.58,1.74c-.78.26-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5,11.13,0,16.18,5.06,8.09-1.51,5.06-9.61-10.11-15.68-3,7.08,10.61,16.69,11.12S1326.77,87.81,1326.77,87.81Z"
          fill="#318099"
        />
        <path
          d="M1309.1,93.48c-1.9-.69,5.54-2.19,11.7-5.88s5.33-8.57,2.52-11.2c-2.64-2.46-13.19-2.87-20.11,8.71a2.3,2.3,0,0,1-2.07,1.11c-.83,0-1-2.27-1-2.27s1.58-17.83-6.11-17.38-8.52,8.76-5.48,15.23,2,9.32-3.14,4.24-5.61-12.77-13.72-8.16,3.07,12.38,11.93,16.11S1311,94.16,1309.1,93.48Z"
          fill="#318099"
        />
      </g> */}
      <g opacity="0.47">
        <path
          d="M453.05,177.1a5.1,5.1,0,0,0,1.58-9.59c-4.37-2.19-10.14-3.12-15.18-1,14.95-6.41,22.6-14.24,12.81-21.36-7.83-5.69-19.92,14.95-22.77,14.95s1.42-8.54,7.83-16.37,5.69-14.23.71-16.37-13.52,1.42-15.66,23.49c0-3.56,1.42-25.62-4.27-23.49s-10,14.24-.71,27c-5.69,2.13-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.65,0,22.77,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.27,14.94,22.06,28.47,22.77C413.67,182.72,439.56,179.12,453.05,177.1Z"
          fill="url(#ed1e1f9b-c26c-49bd-a531-344686d20627)"
        />
        <path
          d="M444.44,175.18c.51-4.05-7.07-8.09-13.14-3,9.1-8.08,11.12-14.66,6.57-14.66s-14.66,8.6-16.68,8.6,4.46-3.94,9-9.5,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.78-16,15a2.29,2.29,0,0,1-1.58,1.74c-.78.26-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.06,11.13,0,16.18,5.06,8.09-1.52,5.06-9.6-10.11-15.67-3,7.08,10.61,16.68,11.12S444.44,175.18,444.44,175.18Z"
          fill="#318099"
        />
        <path
          d="M426.78,180.85c-1.9-.69,5.53-2.19,11.7-5.88s5.33-8.57,2.52-11.2c-2.64-2.46-13.2-2.87-20.11,8.71a2.31,2.31,0,0,1-2.07,1.11c-.83,0-1-2.27-1-2.27s1.59-17.83-6.1-17.38-8.53,8.76-5.48,15.23,2,9.32-3.14,4.24-5.61-12.77-13.72-8.16,3.06,12.38,11.93,16.11S428.68,181.53,426.78,180.85Z"
          fill="#318099"
        />
      </g>
      <g id="aa654834-b858-421c-8514-b85faa720ac3" data-name="decor">
        <path
          d="M1007.72,74.06c-1.8-4.45-5.55-13.2-4.3-20.56s2.64-16.54.83-19.31"
          fill="#3499c1"
        />
        <path
          d="M1011.75,23.07c1.39,4.59,2.22,5,0,10.42s-6.39,20.29-6.25,23.34S1009.25,72,1009.25,72"
          fill="#3499c1"
        />
        <path
          d="M1013.14,45.86c1,1.66-1,6.53-3.89,11s-3.75,17.23-3.75,17.23"
          fill="#3499c1"
        />
        <path
          d="M1003.14,16.54c-.56-2.5-2.64-1.95-2.36,0s.69,3.06,0,3.2-2.37,0-1.67,3.33l.69,3.33s-3.75-1.8.28,3.76c-.69.69-2.64,1,.56,3.47-.28.56-2.37.56-1,2.5s5.78,4.31,5.78,4.31,3.95-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.62,0-5.7c.14-1,3.33-6.25,0-4.58.42-1.53,1.39-6.53-1.39-2.64A5.29,5.29,0,0,0,1003.14,16.54Z"
          fill="#3499c1"
        />
        <path
          d="M1005.3,40.44s4-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.62,0-5.7c.14-1,3.34-6.25,0-4.58.42-1.53,1.39-6.53-1.39-2.64a5.29,5.29,0,0,0-1-2.92"
          fill="#3499c1"
        />
        <path
          d="M1005.36,40.44s1.53-7.64-.14-8.89-2.64-.56-2.64-.56,3.48-6.67.42-4.31c.14-1,2.5-5.42,0-4.58.14-.7.14-4.87-1.11-3.61a17.24,17.24,0,0,1,0-3.06"
          fill="#3499c1"
        />
        <path
          d="M1003.14,16.54c-.56-2.5-2.64-1.95-2.36,0s.69,3.06,0,3.2-2.37,0-1.67,3.33l.69,3.33s-3.75-1.8.28,3.76c-.69.69-2.64,1,.56,3.47-.28.56-2.37.56-1,2.5s5.78,4.31,5.78,4.31"
          fill="#3499c1"
        />
        <path
          d="M1010.36,1.67c-.55-2.5-2.64-1.94-2.36,0s.7,3.06,0,3.2-2.36,0-1.67,3.33l.7,3.34s-3.75-1.81.28,3.75c-.7.69-2.64,1,.55,3.47-.28.56-2.36.56-1,2.5s5.78,4.31,5.78,4.31,3.94-7.64,2.28-8.89-2.23.83-2.23.83,3.48-8.61,0-5.69c.14-1,3.34-6.26,0-4.59.42-1.53,1.39-6.53-1.39-2.64A5.24,5.24,0,0,0,1010.36,1.67Z"
          fill="#3499c1"
        />
        <path
          d="M1012.53,25.57s4-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.61,0-5.69c.13-1,3.33-6.26,0-4.59C1013,5.7,1014,.7,1011.2,4.59a5.29,5.29,0,0,0-1-2.92"
          fill="#3499c1"
        />
        <path
          d="M1012.59,25.57s1.52-7.64-.14-8.89-2.64-.56-2.64-.56,3.47-6.67.41-4.3c.14-1,2.5-5.42,0-4.59.14-.69.14-4.86-1.11-3.61a17.24,17.24,0,0,1,0-3.06"
          fill="#3499c1"
        />
        <path
          d="M1010.36,1.67c-.55-2.5-2.64-1.94-2.36,0s.7,3.06,0,3.2-2.36,0-1.67,3.33l.7,3.34s-3.75-1.81.28,3.75c-.7.69-2.64,1,.55,3.47-.28.56-2.36.56-1,2.5s5.78,4.31,5.78,4.31"
          fill="#3499c1"
        />
        <path
          d="M1019.88,23.73c.34-2.54-1.81-2.73-2.22-.81s-.4,3.11-1.1,3-2.21-.81-2.71,2.56l-.49,3.37s-2.9-3-1,3.62c-.89.41-2.81,0-.67,3.45-.45.43-2.41-.29-1.77,2s3.94,6,3.94,6,6.34-5.82,5.2-7.57-2.37,0-2.37,0,6.22-6.9,2-5.35c.47-.87,5.28-4.73,1.58-4.31.91-1.29,3.55-5.65-.4-3A5.28,5.28,0,0,0,1019.88,23.73Z"
          fill="#3499c1"
        />
        <path
          d="M1013.7,46.92s6.34-5.82,5.2-7.57-2.37,0-2.37,0,6.22-6.89,2-5.35c.47-.86,5.28-4.72,1.58-4.3.91-1.3,3.55-5.66-.4-3a5.25,5.25,0,0,0,.09-3.07"
          fill="#3499c1"
        />
        <path
          d="M1013.76,46.94s4.06-6.65,2.92-8.4-2.29-1.43-2.29-1.43,5.56-5.07,1.87-3.9c.47-.86,4.21-4.23,1.58-4.3.37-.61,1.8-4.52.2-3.78a16.68,16.68,0,0,1,1.05-2.87"
          fill="#3499c1"
        />
        <path
          d="M1019.88,23.73c.34-2.54-1.81-2.73-2.22-.81s-.4,3.11-1.1,3-2.21-.81-2.71,2.56l-.49,3.37s-2.9-3-1,3.62c-.89.41-2.81,0-.67,3.45-.45.43-2.41-.29-1.77,2s3.94,6,3.94,6"
          fill="#3499c1"
        />
      </g>
      <path
        d="M785.9,202.29c-3.23,1.38-5.77,3.23-6.17,6.4s-1,5.7-2.77,6c-.52.64,0,1,0,1s2.77.12,3.29,1.44a6.35,6.35,0,0,0,7,3.4c-.87-.4-4.61-.75-3.75-3.4s2.77-2.42,2.77-2.42.23,2.48,1,3.11,3.34,0,3.34,0-2,.06-2-1.21,0-3.74-1-3.74.29.17,1.27-1.39.06-3.4,1.73-4.09c-3.51.29-4.15,4.09-4.15,4.09H785s-2-1.15-2-2.82a23.2,23.2,0,0,1,.64-4.55Z"
        fill="#314e60"
        opacity="0.68"
      />
      <path
        d="M636.4,50.4c-3.12,1.59-5.53,3.6-5.72,6.79S630,63,628.31,63.36c-.47.67.07,1,.07,1s2.77-.07,3.37,1.22A6.38,6.38,0,0,0,639,68.48c-.88-.34-4.65-.44-4-3.14s2.6-2.6,2.6-2.6.4,2.46,1.18,3,3.34-.22,3.34-.22-1.95.18-2-1.08-.24-3.74-1.28-3.67.3.15,1.17-1.46-.16-3.4,1.46-4.2c-3.49.52-3.87,4.36-3.87,4.36l-1.44.09s-2-1-2.2-2.68a22.69,22.69,0,0,1,.33-4.59Z"
        fill="#314e60"
        opacity="0.33"
      />
      <path
        d="M174.66,69.83c-4.56,3.46-7.85,7.37-7.25,12.54s.59,9.43-2,10.57c-.58,1.2.38,1.55.38,1.55s4.42-.91,5.76,1A10.41,10.41,0,0,0,184,98.11c-1.53-.3-7.59.62-7.26-3.92s3.43-4.91,3.43-4.91,1.33,3.83,2.77,4.54,5.28-1.31,5.28-1.31-3.07.86-3.57-1.15-1.47-5.92-3.11-5.52.53.16,1.47-2.68-1.24-5.4,1.13-7.15c-5.45,1.83-5,8.1-5,8.1l-2.28.56s-3.55-1.06-4.3-3.68a37.57,37.57,0,0,1-.78-7.45Z"
        fill="#314e60"
        opacity="0.68"
      />
      <path
        d="M448.71,37.67c7.81,3.35,14,7.81,14.93,15.49s2.51,13.81,6.7,14.51c1.25,1.53,0,2.37,0,2.37s-6.7.28-8,3.49-7,9.91-17,8.23c2.09-1,11.16-1.81,9.07-8.23s-6.7-5.86-6.7-5.86-.56,6-2.37,7.53-8.09,0-8.09,0,4.74.14,4.74-2.93,0-9.07,2.51-9.07-.69.42-3.07-3.34-.14-8.24-4.18-9.91c8.51.7,10,9.91,10,9.91h3.49s4.75-2.8,4.89-6.84-1.54-11-1.54-11Z"
        fill="#314e60"
      />
      <path
        d="M30.68,41.05C19.87,45.68,11.38,51.85,10,62.46S6.56,81.57.77,82.53c-1.73,2.12,0,3.28,0,3.28s9.26.39,11,4.82,9.65,13.7,23.54,11.39c-2.9-1.35-15.44-2.51-12.54-11.39S32,82.53,32,82.53s.77,8.3,3.28,10.42S46.5,93,46.5,93s-6.56.19-6.56-4,0-12.54-3.47-12.54,1,.58,4.24-4.63S40.9,60.34,46.5,58c-11.77,1-13.89,13.7-13.89,13.7H27.78S21.22,67.87,21,62.27,23.15,47,23.15,47Z"
        fill="#314e60"
      />
      <g>
        <g>
          <path
            d="M1064.68,205.73s-2.78-6.18-4.54-7.84-1.57-2.22-2.07-1.92c-1.5.91-4.11-1.28-1.07-3.52,3.79-2.79,6.24-.74,4.26,1.92.48,1.28.91,1.89,1.18,2.56s3.14,1.44,3.62,8.8Z"
            fill="#318099"
          />
          <ellipse
            cx="1058.84"
            cy="193.55"
            rx="2.64"
            ry="1.25"
            transform="translate(70.27 619.38) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1063.93,199.92a20.59,20.59,0,0,0,0-3.15c0-.85-.59-2.24-.69-3.25s-.11-4.05-3.41-5.06c-1.76.26-2.78-2.08,0-4.11s4.27-1.72,4.67-.58c.27.76,1.94,2,1.14,5.27s-.48,5.39-.22,5.81a7.34,7.34,0,0,1,1.6,5.07c-.26,2.77-1,6.34-1,6.34Z"
            fill="#318099"
          />
          <ellipse
            cx="1061.5"
            cy="185.6"
            rx="2.64"
            ry="1.25"
            transform="translate(75.12 619.52) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1066.06,197.36c.16-1.23,1.34-2.61,1.92-3.79.27-.52.78-1.17,1.22-1.89a2.94,2.94,0,0,0-.4-3.57c-1.06-1.1-1.13-3.27,1.1-3.23s4.43.7,5.07,2.46a1.56,1.56,0,0,1-1.25,1.94,2.31,2.31,0,0,0-1.49,1.55,6.24,6.24,0,0,1-1.63,2.74c-.86.91-2.51,4.22-2.35,8.43s-.91,4.37-1.17,4.26-1-.53-1-.53Z"
            fill="#318099"
          />
          <ellipse
            cx="1071.74"
            cy="187.04"
            rx="1.25"
            ry="2.64"
            transform="translate(573.65 1154.27) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1067,198.51a8,8,0,0,0-1.58-3.66c-.26-.42-.58-2.56.22-5.81.65-2.66-.27-4-.89-4.71a4.2,4.2,0,0,1-1.57,2.74c1,.05,1.44.11,1.55,1.28s-.75,1.17,0,4.69,2.08,4.11,1.71,5.87a28.51,28.51,0,0,0,0,5.5c.11-.64.23-1.39.34-2.17Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1060,188.51a4.39,4.39,0,0,1,2.3,1.67,3.54,3.54,0,0,1,.09-2.47A5.79,5.79,0,0,1,1060,188.51Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1062.75 191.02 1062.75 191.02 1062.75 191.02 1062.75 191.02"
              fill="#318099"
            />
          </g>
          <path
            d="M1068.25,202c-.16-4.21,1.49-7.52,2.35-8.43,1.38-1.22,1.83-3.86,2.82-4.35a6.71,6.71,0,0,1-2.61-.28,2,2,0,0,1,.63,2.75c-.54,1.39-1.16,1.51-1.91,2.68a16,16,0,0,0-1.65,4.43c-.22,1.07,0,5.17-.22,5.92s-.58,1.54-.58,1.54l.72-.45A8,8,0,0,0,1068.25,202Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1064.14,203.65c0-1-1.33-1.7-1.76-3.3s-1.33-2-2.13-3.1a2.31,2.31,0,0,1-.58-2,2.89,2.89,0,0,1-1.23.69h0a16.37,16.37,0,0,0,1.7,1.92c1.76,1.66,4.54,7.84,4.54,7.84C1064.73,205.31,1064.14,204.61,1064.14,203.65Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1064.68,199.39a18.74,18.74,0,0,0-.38-3.79c-.16-.8-.69-4.37-1.12-4.48a4,4,0,0,0-.43-.08,6.7,6.7,0,0,1,.43,1.89h0s.39,1.63.61,2.8a3.83,3.83,0,0,1,.14,1,2.44,2.44,0,0,1,0,.26c0,.81.28.54.09,1.6C1064.22,199.26,1064.57,200.19,1064.68,199.39Z"
            fill="#318099"
          />
          <path
            d="M1071.88,185.79c-1.3-.35-2.46-.16-2.66.47-.11.36.14.8.62,1.19C1069.46,186.21,1071,185.87,1071.88,185.79Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1060.81,184.56c-1.21.81-1.89,1.93-1.5,2.51a.87.87,0,0,0,.71.32c-1-1.15,2.47-3.41,2.72-3.57A4.22,4.22,0,0,0,1060.81,184.56Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1058.07,192.68l-.3.1c-1,.77-1.47,1.72-1.13,2.23a1,1,0,0,0,.9.33c0-.09.2-.17.84-.18l.09,0C1056.16,194.6,1058.07,192.68,1058.07,192.68Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path
          d="M1069.37,189s.72,1.26-.83,3.73-2.18,3.7-2.18,3.7"
          fill="#318099"
        />
        <path d="M1070.2,185s-3,.49-1,2.47" fill="#318099" />
        <path d="M1059.62,185.26s-2.39,1.82.28,2.65" fill="#318099" />
        <path d="M1056.83,192.93s-2.08,2.07.6,2.9" fill="#318099" />
      </g>
      <g>
        <g>
          <path
            d="M1224.09,186.54s-3.55-7.91-5.8-10-2-2.85-2.67-2.46c-1.91,1.16-5.25-1.64-1.36-4.5,4.86-3.58,8-1,5.46,2.45.61,1.64,1.16,2.42,1.5,3.28.27.68,4,1.84,4.64,11.26Z"
            fill="#318099"
          />
          <ellipse
            cx="1216.61"
            cy="170.95"
            rx="3.38"
            ry="1.6"
            transform="translate(109.26 703.04) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1223.13,179.1a25.54,25.54,0,0,0,0-4c.07-1.1-.75-2.87-.89-4.17s-.13-5.19-4.36-6.48c-2.25.34-3.55-2.67,0-5.26s5.47-2.2,6-.74c.34,1,2.47,2.58,1.45,6.75s-.62,6.89-.28,7.44a9.33,9.33,0,0,1,2,6.48c-.34,3.55-1.23,8.13-1.23,8.13Z"
            fill="#318099"
          />
          <ellipse
            cx="1220.03"
            cy="160.77"
            rx="3.38"
            ry="1.6"
            transform="matrix(0.83, -0.55, 0.55, 0.83, 115.47, 703.23)"
            fill="#318099"
          />
          <path
            d="M1225.86,175.83c.21-1.57,1.71-3.35,2.46-4.85.34-.68,1-1.5,1.56-2.43a3.78,3.78,0,0,0-.51-4.57c-1.36-1.41-1.45-4.18,1.41-4.13,2.68.05,5.66.89,6.48,3.14a2,2,0,0,1-1.6,2.5,2.93,2.93,0,0,0-1.9,2,8.23,8.23,0,0,1-2.09,3.52c-1.1,1.16-3.21,5.39-3,10.79s-1.16,5.59-1.5,5.46-1.3-.69-1.3-.69Z"
            fill="#318099"
          />
          <ellipse
            cx="1233.13"
            cy="162.62"
            rx="1.6"
            ry="3.38"
            transform="translate(710.24 1291.17) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1227.07,177.29a10.09,10.09,0,0,0-2-4.67c-.34-.55-.75-3.28.28-7.44.84-3.42-.34-5.09-1.13-6a5.5,5.5,0,0,1-2,3.5c1.23.07,1.84.14,2,1.64s-1,1.5,0,6,2.66,5.25,2.18,7.51a36.35,36.35,0,0,0,0,7c.14-.82.29-1.78.44-2.77Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1218.09,164.5a5.54,5.54,0,0,1,2.94,2.14,4.52,4.52,0,0,1,.12-3.17A7.55,7.55,0,0,1,1218.09,164.5Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1221.62 167.71 1221.62 167.71 1221.62 167.71 1221.62 167.71"
              fill="#318099"
            />
          </g>
          <path
            d="M1228.66,181.77c-.2-5.4,1.91-9.63,3-10.79,1.77-1.57,2.34-4.94,3.61-5.58a8.34,8.34,0,0,1-3.34-.36c1.16,1.16,1.48,1.76.8,3.53s-1.48,1.93-2.44,3.43a20.84,20.84,0,0,0-2.12,5.67c-.27,1.36.07,6.62-.27,7.58s-.75,2-.75,2l.93-.58C1228.46,186,1228.77,184.56,1228.66,181.77Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1223.41,183.88c0-1.23-1.71-2.18-2.26-4.23s-1.7-2.53-2.73-4a3,3,0,0,1-.75-2.53,3.55,3.55,0,0,1-1.57.89h0a22.3,22.3,0,0,0,2.19,2.46c2.25,2.12,5.8,10,5.8,10C1224.16,186,1223.41,185.11,1223.41,183.88Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1224.09,178.42a23.53,23.53,0,0,0-.48-4.85c-.2-1-.89-5.59-1.43-5.73a4.44,4.44,0,0,0-.56-.1,8.73,8.73,0,0,1,.56,2.42h0s.49,2.08.77,3.58a4.55,4.55,0,0,1,.18,1.34c0,.09,0,.2,0,.32,0,1,.36.69.11,2C1223.51,178.26,1224,179.44,1224.09,178.42Z"
            fill="#318099"
          />
          <path
            d="M1233.31,161c-1.66-.44-3.15-.2-3.4.6-.15.47.18,1,.79,1.52C1230.21,161.55,1232.2,161.12,1233.31,161Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1219.14,159.44c-1.56,1-2.42,2.47-1.93,3.21a1.11,1.11,0,0,0,.91.41c-1.33-1.47,3.17-4.37,3.49-4.57A5.33,5.33,0,0,0,1219.14,159.44Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1215.63,169.84l-.38.12c-1.25,1-1.89,2.2-1.45,2.86a1.23,1.23,0,0,0,1.15.41c0-.11.25-.2,1.08-.22l.11,0C1213.18,172.3,1215.63,169.84,1215.63,169.84Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path
          d="M1230.09,165.05s.93,1.62-1.06,4.79-2.78,4.74-2.78,4.74"
          fill="#318099"
        />
        <path d="M1231.16,160s-3.81.64-1.27,3.17" fill="#318099" />
        <path d="M1217.62,160.33s-3.07,2.34.35,3.4" fill="#318099" />
        <path d="M1214,170.16s-2.66,2.65.77,3.71" fill="#318099" />
      </g>
      {/* <g>
        <g>
          <path
            d="M1223.22,75.86s-3-6.7-4.91-8.5-1.71-2.41-2.26-2.08c-1.61,1-4.44-1.38-1.15-3.81,4.11-3,6.76-.81,4.62,2.08.52,1.39,1,2,1.27,2.77s3.41,1.56,3.93,9.54Z"
            fill="#318099"
          />
          <ellipse
            cx="1216.89"
            cy="62.66"
            rx="2.86"
            ry="1.36"
            transform="translate(169.33 685.04) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1222.41,69.56a22.7,22.7,0,0,0,0-3.41c.06-.92-.64-2.43-.75-3.52s-.12-4.39-3.7-5.49c-1.9.29-3-2.25,0-4.45s4.64-1.86,5.07-.63c.29.82,2.09,2.19,1.23,5.71s-.52,5.84-.23,6.3a8,8,0,0,1,1.73,5.49c-.29,3-1,6.87-1,6.87Z"
            fill="#318099"
          />
          <ellipse
            cx="1219.78"
            cy="54.05"
            rx="2.86"
            ry="1.36"
            transform="translate(174.58 685.2) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1224.72,66.79c.17-1.33,1.44-2.83,2.08-4.11.29-.57.84-1.27,1.32-2a3.2,3.2,0,0,0-.43-3.87c-1.15-1.19-1.23-3.54,1.19-3.49,2.27,0,4.8.75,5.49,2.65A1.69,1.69,0,0,1,1233,58a2.53,2.53,0,0,0-1.61,1.68,6.75,6.75,0,0,1-1.77,3c-.92,1-2.71,4.57-2.54,9.13s-1,4.74-1.27,4.62-1.1-.57-1.1-.57Z"
            fill="#318099"
          />
          <ellipse
            cx="1230.87"
            cy="55.61"
            rx="1.36"
            ry="2.86"
            transform="translate(810.79 1213.91) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1225.74,68a8.66,8.66,0,0,0-1.71-4c-.29-.46-.64-2.77.23-6.3.71-2.89-.29-4.3-1-5.1a4.62,4.62,0,0,1-1.7,3c1,0,1.56.11,1.68,1.38s-.81,1.27,0,5.09,2.25,4.45,1.84,6.35a30.87,30.87,0,0,0,0,6c.12-.69.25-1.5.37-2.34Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1218.14,57.2a4.71,4.71,0,0,1,2.49,1.81,3.82,3.82,0,0,1,.1-2.68A6.43,6.43,0,0,1,1218.14,57.2Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1221.13 59.92 1221.13 59.92 1221.13 59.92 1221.13 59.92"
              fill="#318099"
            />
          </g>
          <path
            d="M1227.09,71.81c-.17-4.56,1.62-8.14,2.54-9.13,1.5-1.32,2-4.18,3.06-4.72a7.15,7.15,0,0,1-2.83-.3c1,1,1.26,1.48.68,3s-1.26,1.63-2.06,2.9a17.75,17.75,0,0,0-1.8,4.8c-.23,1.15.06,5.6-.23,6.41s-.63,1.67-.63,1.67l.78-.49C1226.92,75.37,1227.18,74.18,1227.09,71.81Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1222.64,73.6c0-1-1.44-1.84-1.91-3.58s-1.44-2.14-2.31-3.35a2.53,2.53,0,0,1-.63-2.14,3.05,3.05,0,0,1-1.33.75h0a17.72,17.72,0,0,0,1.85,2.08c1.9,1.8,4.91,8.5,4.91,8.5C1223.28,75.39,1222.64,74.64,1222.64,73.6Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1223.22,69a19.73,19.73,0,0,0-.41-4.1c-.17-.87-.75-4.74-1.21-4.85a3.2,3.2,0,0,0-.47-.09,7.24,7.24,0,0,1,.47,2.05h0s.42,1.76.65,3a3.78,3.78,0,0,1,.16,1.13c0,.08,0,.17,0,.28,0,.88.3.58.09,1.73C1222.73,68.85,1223.1,69.85,1223.22,69Z"
            fill="#318099"
          />
          <path
            d="M1231,54.24c-1.4-.37-2.67-.16-2.88.51-.12.4.15.87.67,1.3C1228.4,54.7,1230.08,54.34,1231,54.24Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1219,52.92c-1.32.87-2,2.09-1.63,2.71a1,1,0,0,0,.77.36c-1.13-1.25,2.68-3.71,2.95-3.87A4.5,4.5,0,0,0,1219,52.92Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1216.06,61.72l-.32.1c-1.06.84-1.6,1.86-1.23,2.42a1.06,1.06,0,0,0,1,.35c0-.09.22-.17.92-.18l.09,0C1214,63.8,1216.06,61.72,1216.06,61.72Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path d="M1228.3,57.67s.78,1.37-.9,4-2.35,4-2.35,4" fill="#318099" />
        <path d="M1229.2,53.4s-3.22.54-1.07,2.69" fill="#318099" />
        <path d="M1217.74,53.67s-2.6,2,.3,2.88" fill="#318099" />
        <path d="M1214.72,62s-2.26,2.24.64,3.14" fill="#318099" />
      </g> */}
      <g>
        <g>
          <path
            d="M1074.61,71.72s-4.15-9.25-6.78-11.72-2.36-3.32-3.11-2.87c-2.23,1.36-6.13-1.91-1.59-5.26,5.67-4.18,9.32-1.11,6.38,2.87.71,1.91,1.35,2.82,1.75,3.83.32.79,4.7,2.15,5.42,13.15Z"
            fill="#318099"
          />
          <ellipse
            cx="1065.88"
            cy="53.51"
            rx="3.94"
            ry="1.87"
            transform="translate(149.08 599.8) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1073.49,63c.32-1.75-.08-3.43,0-4.7s-.88-3.35-1-4.86-.15-6.06-5.1-7.57c-2.62.4-4.14-3.11,0-6.14s6.4-2.57,7-.86c.39,1.12,2.89,3,1.69,7.87s-.72,8-.32,8.69a11,11,0,0,1,2.39,7.57c-.4,4.14-1.43,9.48-1.43,9.48Z"
            fill="#318099"
          />
          <ellipse
            cx="1069.86"
            cy="41.63"
            rx="3.94"
            ry="1.87"
            transform="translate(156.33 600.02) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1076.68,59.2c.24-1.83,2-3.9,2.87-5.65.39-.79,1.15-1.76,1.82-2.84a4.41,4.41,0,0,0-.6-5.33c-1.58-1.65-1.69-4.88,1.65-4.82,3.13.06,6.61,1,7.57,3.66.5,1.4-.62,2.53-1.88,2.91a3.47,3.47,0,0,0-2.22,2.31,9.36,9.36,0,0,1-2.44,4.11c-1.27,1.35-3.74,6.29-3.5,12.59s-1.36,6.53-1.76,6.37-1.51-.79-1.51-.79Z"
            fill="#318099"
          />
          <ellipse
            cx="1085.16"
            cy="43.78"
            rx="1.87"
            ry="3.94"
            transform="translate(719.82 1066.54) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1078.08,60.92a11.79,11.79,0,0,0-2.36-5.46c-.4-.64-.87-3.83.32-8.69,1-4-.4-5.93-1.32-7a6.27,6.27,0,0,1-2.35,4.08c1.44.08,2.16.16,2.32,1.92s-1.12,1.75,0,7,3.1,6.14,2.55,8.77a42.07,42.07,0,0,0-.06,8.22c.16-.95.34-2.08.51-3.24Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1067.61,46a6.53,6.53,0,0,1,3.43,2.5,5.21,5.21,0,0,1,.14-3.7A8.71,8.71,0,0,1,1067.61,46Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1071.72 49.73 1071.72 49.73 1071.72 49.73 1071.72 49.73"
              fill="#318099"
            />
          </g>
          <path
            d="M1080,66.14c-.24-6.3,2.23-11.24,3.5-12.59,2.07-1.84,2.74-5.77,4.22-6.51a9.86,9.86,0,0,1-3.9-.43c1.36,1.36,1.73,2,.94,4.13s-1.74,2.25-2.85,4a24,24,0,0,0-2.47,6.62c-.32,1.59.08,7.73-.32,8.84s-.88,2.31-.88,2.31l1.09-.68C1079.71,71,1080.07,69.4,1080,66.14Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1073.81,68.61c0-1.44-2-2.55-2.63-4.94s-2-3-3.19-4.63-.79-1.83-.87-2.94a4.3,4.3,0,0,1-1.84,1h0a25.7,25.7,0,0,0,2.55,2.87c2.63,2.47,6.78,11.72,6.78,11.72C1074.69,71.08,1073.81,70,1073.81,68.61Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1074.61,62.23a27.23,27.23,0,0,0-.56-5.66c-.24-1.19-1-6.53-1.68-6.69a6.38,6.38,0,0,0-.64-.12,9.79,9.79,0,0,1,.64,2.83h0s.58,2.42.9,4.17a5.23,5.23,0,0,1,.22,1.57c0,.11,0,.24,0,.38,0,1.22.42.8.13,2.38C1073.93,62.05,1074.45,63.43,1074.61,62.23Z"
            fill="#318099"
          />
          <path
            d="M1085.37,41.91c-1.94-.52-3.68-.23-4,.7-.17.55.21,1.2.92,1.78C1081.75,42.54,1084.07,42,1085.37,41.91Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1068.83,40.07c-1.82,1.21-2.82,2.89-2.25,3.75a1.31,1.31,0,0,0,1.06.49c-1.55-1.73,3.7-5.11,4.07-5.34A6.31,6.31,0,0,0,1068.83,40.07Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1064.73,52.22l-.44.14c-1.46,1.15-2.2,2.57-1.69,3.33a1.48,1.48,0,0,0,1.34.49c0-.13.3-.24,1.26-.26l.12,0C1061.87,55.08,1064.73,52.22,1064.73,52.22Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path
          d="M1081.61,46.63s1.09,1.89-1.24,5.59-3.24,5.53-3.24,5.53"
          fill="#318099"
        />
        <path d="M1082.86,40.75s-4.44.74-1.48,3.7" fill="#318099" />
        <path d="M1067.05,41.12s-3.58,2.72.42,4" fill="#318099" />
        <path d="M1062.88,52.59s-3.11,3.09.89,4.33" fill="#318099" />
      </g>
      {/* <g>
        <path
          d="M1310.86,142.75s10,20.21,53.64,17S1385.43,146,1377,142.68,1310.86,142.75,1310.86,142.75Z"
          fill="#0e3b68"
          opacity="0.32"
        />
        <g>
          <path
            d="M1394.17,145.2a6,6,0,0,0,1.86-11.33c-5.17-2.58-12-3.68-17.93-1.14,17.65-7.56,26.69-16.81,15.13-25.21-9.24-6.72-23.53,17.65-26.89,17.65s1.68-10.09,9.24-19.33,6.73-16.81.84-19.33-16,1.68-18.49,27.73c0-4.2,1.68-30.25-5-27.73s-11.77,16.81-.84,31.94c-6.72,2.52-5.88-4.21-5.88-4.21S1342.8,89,1331,94.07s-8.41,18.49,0,26.9,8.4,13.45-2.52,8.4-16-16.81-26.06-5,17.65,26.05,33.62,26.89C1347.66,151.83,1378.23,147.58,1394.17,145.2Z"
            fill="url(#a4a1070f-2d1e-4afb-82d2-913a3b28768f)"
          />
          <path
            d="M1384,142.93c.6-4.78-8.36-9.55-15.52-3.58,10.74-9.56,13.13-17.32,7.76-17.32s-17.32,10.15-19.71,10.15,5.27-4.64,10.65-11.21,2.5-11.66-1.68-13.45c-3.92-1.68-15.81,2.09-18.86,17.72a2.72,2.72,0,0,1-1.86,2.06c-.93.3-2-2.13-2-2.13s-5.37-20.45-13.73-16.87-6,13.14,0,19.11,6,9.55-1.79,6-11.34-11.94-18.51-3.59,8.36,12.54,19.7,13.14S1384,142.93,1384,142.93Z"
            fill="url(#b6eb3326-c09a-42e9-aae4-ca8574802b5c)"
          />
          <path
            d="M1363.14,149.62c-2.25-.8,6.53-2.58,13.81-6.94s6.3-10.12,3-13.22c-3.12-2.91-15.58-3.39-23.74,10.28a2.74,2.74,0,0,1-2.46,1.31c-1,0-1.13-2.67-1.13-2.67s1.87-21.07-7.21-20.53-10.07,10.34-6.47,18,2.38,11-3.71,5-6.63-15.08-16.2-9.64,3.62,14.63,14.09,19S1365.39,150.43,1363.14,149.62Z"
            fill="url(#f02313d8-d10b-4b50-8a7b-ac484699db62)"
          />
        </g>
      </g> */}
      {/* <g>
        <path
          d="M1381,263.54c6.6-1,8.09-9.92,2.12-12.9s-13.63-4.2-20.41-1.3c20.1-8.61,30.39-19.14,17.23-28.7-10.53-7.66-26.8,20.09-30.62,20.09s1.91-11.48,10.52-22,7.66-19.14,1-22-18.18,1.92-21,31.58c0-4.78,1.91-34.45-5.74-31.58s-13.4,19.14-1,36.37c-7.66,2.87-6.7-4.79-6.7-4.79s-3.83-28.71-17.23-23-9.57,21.06,0,30.63,9.57,15.31-2.87,9.57-18.18-19.14-29.66-5.75,20.09,29.67,38.28,30.63C1328.08,271.09,1362.88,266.25,1381,263.54Z"
          fill="url(#bdf202e7-6d79-486b-9181-659313282056)"
        />
        <path
          d="M1369.46,261c.68-5.44-9.52-10.88-17.68-4.08,12.24-10.87,15-19.71,8.84-19.71s-19.72,11.55-22.43,11.55,6-5.29,12.11-12.76,2.85-13.28-1.91-15.31c-4.46-1.92-18,2.38-21.47,20.17a3.11,3.11,0,0,1-2.12,2.35c-1,.34-2.25-2.43-2.25-2.43s-6.12-23.29-15.64-19.21-6.79,15,0,21.76,6.8,10.87-2,6.79S1292,236.48,1283.8,246s9.52,14.27,22.43,14.95S1369.46,261,1369.46,261Z"
          fill="url(#f4c3843d-6d7f-4382-8706-3bd69bb1e03b)"
        />
        <path
          d="M1345.71,268.58c-2.56-.93,7.44-2.95,15.72-7.91s7.18-11.53,3.39-15.06c-3.55-3.31-17.74-3.85-27,11.71a3.09,3.09,0,0,1-2.79,1.49c-1.11,0-1.3-3-1.3-3s2.13-24-8.2-23.37-11.47,11.77-7.37,20.47,2.71,12.53-4.22,5.7-7.55-17.16-18.45-11,4.12,16.65,16,21.67S1348.27,269.5,1345.71,268.58Z"
          fill="url(#b8ef41a7-c67e-4bc7-b8fd-3f70a819078e)"
        />
      </g> */}
      {/* <g>
        <path
          d="M1402.57,505.21a5.11,5.11,0,0,0,1.58-9.6c-4.38-2.18-10.14-3.12-15.18-1,15-6.4,22.6-14.23,12.81-21.35-7.83-5.69-19.93,14.95-22.77,14.95s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37S1374,456.93,1371.89,479c0-3.55,1.42-25.62-4.27-23.48s-10,14.23-.71,27c-5.7,2.14-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.66,0,22.78,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.28,14.94,22.07,28.47,22.78C1363.19,510.83,1389.07,507.23,1402.57,505.21Z"
          fill="url(#b42ae52d-ce66-4aff-9c73-78f5c68831b8)"
        />
        <path
          d="M1394,503.28c.51-4-7.07-8.08-13.14-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.06,11.12,0,16.18,5.06,8.09-1.52,5.06-9.6-10.12-15.67-3,7.08,10.62,16.68,11.12S1394,503.28,1394,503.28Z"
          fill="url(#a70e248e-150a-495e-9c17-0d1962597894)"
        />
        <path
          d="M1376.3,509c-1.9-.69,5.53-2.2,11.7-5.89s5.33-8.57,2.52-11.19c-2.64-2.47-13.2-2.87-20.11,8.7a2.29,2.29,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.53,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17,3.06,12.39,11.93,16.12S1378.2,509.64,1376.3,509Z"
          fill="url(#aa4ea4da-d765-4629-88cd-d401b1f1e978)"
        />
      </g> */}
      {/* <g>
        <path
          d="M1330.24,275.87a5.1,5.1,0,0,0,1.58-9.59c-4.38-2.19-10.14-3.12-15.18-1,14.95-6.41,22.6-14.24,12.81-21.36-7.83-5.69-19.93,15-22.77,15s1.42-8.54,7.83-16.37,5.69-14.23.71-16.37-13.53,1.43-15.66,23.49c0-3.56,1.42-25.62-4.27-23.49s-10,14.24-.71,27.05c-5.7,2.13-5-3.56-5-3.56s-2.84-21.35-12.81-17.08-7.11,15.66,0,22.77,7.12,11.39-2.13,7.12-13.52-14.23-22.07-4.27,15,22.06,28.47,22.77C1290.86,281.49,1316.74,277.89,1330.24,275.87Z"
          fill="url(#a9d81c9b-7588-41b7-932f-5c9366abb60d)"
        />
        <path
          d="M1321.63,274c.51-4.05-7.08-8.09-13.14-3,9.1-8.09,11.12-14.67,6.57-14.67s-14.66,8.6-16.68,8.6,4.46-3.94,9-9.5,2.11-9.87-1.43-11.39c-3.31-1.42-13.38,1.78-16,15a2.31,2.31,0,0,1-1.58,1.74c-.78.26-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.28-5.06,11.12,0,16.17,5.05,8.09-1.52,5.06-9.6-10.11-15.67-3,7.08,10.61,16.68,11.12S1321.63,274,1321.63,274Z"
          fill="url(#b1d1cea7-3468-40a9-bfd3-91bda3f5e81d)"
        />
        <path
          d="M1304,279.62c-1.9-.69,5.53-2.19,11.7-5.88s5.33-8.57,2.51-11.2c-2.64-2.46-13.19-2.86-20.1,8.71a2.33,2.33,0,0,1-2.08,1.11c-.82,0-1-2.26-1-2.26s1.58-17.84-6.1-17.39-8.53,8.76-5.48,15.23,2,9.32-3.14,4.24-5.62-12.77-13.72-8.16,3.06,12.38,11.93,16.11S1305.87,280.3,1304,279.62Z"
          fill="url(#e75b55c3-eec0-40da-a7f1-4077924a8954)"
        />
      </g> */}
      <g>
        <path
          d="M965.07,267.3s14.87,20.49,49.65,14.41,42.57,4.59,46.47-2-13.71-21.81-31.45-23.9-64.67,11.53-64.67,11.53"
          fill="#0e3b68"
          opacity="0.32"
        />
        <g>
          <path
            d="M1053.49,268c6.39-1,7.83-9.61,2-12.49s-13.2-4.07-19.76-1.26c19.46-8.34,29.42-18.53,16.68-27.8-10.2-7.41-26,19.46-29.65,19.46s1.85-11.12,10.19-21.31,7.41-18.53.92-21.31-17.6,1.85-20.38,30.58c0-4.64,1.85-33.36-5.56-30.58s-13,18.53-.93,35.21c-7.41,2.78-6.48-4.63-6.48-4.63s-3.71-27.8-16.68-22.24-9.27,20.38,0,29.65,9.26,14.83-2.78,9.27S963.5,232,952.38,245s19.46,28.72,37.07,29.65C1002.21,275.34,1035.91,270.66,1053.49,268Z"
            fill="url(#b0b72e65-da67-4ceb-a0c3-b871a4e3573d)"
          />
          <path
            d="M1042.28,265.52c.66-5.26-9.22-10.53-17.12-3.95,11.85-10.53,14.48-19.09,8.56-19.09s-19.09,11.19-21.72,11.19,5.81-5.12,11.73-12.36,2.76-12.85-1.85-14.83c-4.32-1.85-17.43,2.31-20.79,19.54a3,3,0,0,1-2.05,2.27c-1,.33-2.18-2.35-2.18-2.35s-5.93-22.55-15.14-18.6-6.59,14.49,0,21.07,6.58,10.53-2,6.58-12.5-13.16-20.4-4,9.21,13.82,21.72,14.48S1042.28,265.52,1042.28,265.52Z"
            fill="url(#aa13e0ee-60a7-443e-a0ca-c2068fadecfc)"
          />
          <path
            d="M1019.28,272.91c-2.48-.9,7.2-2.86,15.23-7.66s6.94-11.16,3.28-14.58c-3.44-3.21-17.18-3.73-26.18,11.34a3,3,0,0,1-2.7,1.44c-1.07,0-1.25-2.94-1.25-2.94s2.06-23.23-7.95-22.63-11.1,11.39-7.13,19.82,2.62,12.13-4.09,5.52-7.31-16.62-17.86-10.63,4,16.13,15.53,21S1021.76,273.8,1019.28,272.91Z"
            fill="url(#bd5f5694-4663-4b04-b73e-a49d56b5b898)"
          />
        </g>
      </g>
      {/* <g>
        <ellipse
          cx="458.94"
          cy="363.81"
          rx="26.66"
          ry="5.58"
          fill="url(#a26ae79a-558f-41fb-9669-c8c41f5a23ec)"
        />
        <g>
          <path
            d="M498.64,360.22a5.56,5.56,0,0,0,1.71-10.44c-4.76-2.37-11-3.39-16.51-1,16.26-7,24.58-15.48,13.94-23.22-8.52-6.19-21.68,16.25-24.77,16.25s1.55-9.29,8.51-17.8,6.19-15.48.78-17.8-14.71,1.55-17,25.54c0-3.87,1.55-27.86-4.65-25.54s-10.83,15.48-.77,29.41c-6.19,2.32-5.42-3.87-5.42-3.87s-3.09-23.22-13.93-18.58-7.74,17,0,24.77,7.74,12.39-2.32,7.74-14.71-15.48-24-4.64,16.26,24,31,24.77C455.8,366.33,484,362.41,498.64,360.22Z"
            fill="url(#b566dfc1-8b59-4950-8277-1984ff8192f3)"
          />
          <path
            d="M489.27,358.13c.55-4.4-7.69-8.8-14.29-3.3,9.89-8.8,12.09-15.95,7.14-15.95s-15.94,9.35-18.14,9.35,4.85-4.28,9.8-10.33,2.3-10.73-1.55-12.38c-3.6-1.55-14.55,1.93-17.36,16.31a2.5,2.5,0,0,1-1.72,1.9c-.85.28-1.81-2-1.81-2s-4.95-18.83-12.65-15.53-5.5,12.09,0,17.59,5.5,8.8-1.65,5.5-10.45-11-17-3.3,7.69,11.55,18.14,12.1S489.27,358.13,489.27,358.13Z"
            fill="url(#ff8f5b7d-504a-4de8-aee7-15a046f998fb)"
          />
          <path
            d="M470.06,364.29c-2.06-.74,6-2.38,12.72-6.39s5.81-9.32,2.74-12.18c-2.87-2.68-14.34-3.12-21.86,9.47a2.5,2.5,0,0,1-2.26,1.2c-.89,0-1-2.46-1-2.46s1.73-19.39-6.63-18.9-9.27,9.52-6,16.56,2.19,10.14-3.42,4.61-6.1-13.88-14.92-8.87,3.34,13.47,13,17.52S472.13,365,470.06,364.29Z"
            fill="url(#f3ec731a-d00d-498a-ac8d-234942316d06)"
          />
        </g>
      </g> */}
      {/* <g>
        <ellipse
          cx="502.02"
          cy="378.33"
          rx="18.39"
          ry="3.85"
          fill="url(#bf3d277b-04a3-443c-a2db-085899d44712)"
        />
        <g>
          <path
            d="M529.4,375.85a3.83,3.83,0,0,0,1.18-7.2,13.83,13.83,0,0,0-11.39-.72c11.21-4.8,16.95-10.67,9.61-16-5.87-4.27-14.94,11.21-17.08,11.21s1.07-6.41,5.87-12.28,4.27-10.68.54-12.28-10.14,1.07-11.75,17.62c0-2.67,1.07-19.22-3.2-17.62s-7.47,10.68-.53,20.29c-4.27,1.6-3.74-2.67-3.74-2.67s-2.13-16-9.61-12.81-5.33,11.74,0,17.08,5.34,8.54-1.6,5.34-10.14-10.68-16.55-3.21,11.21,16.55,21.36,17.08C499.86,380.06,519.27,377.36,529.4,375.85Z"
            fill="url(#bfd24747-396b-4e44-99df-0ee44a0e5943)"
          />
          <path
            d="M522.94,374.41c.38-3-5.31-6.07-9.86-2.28,6.83-6.07,8.34-11,4.93-11s-11,6.45-12.51,6.45,3.34-2.95,6.76-7.12,1.58-7.4-1.07-8.54c-2.49-1.07-10,1.33-12,11.25a1.73,1.73,0,0,1-1.18,1.31c-.59.19-1.25-1.35-1.25-1.35s-3.42-13-8.73-10.72-3.79,8.34,0,12.14,3.8,6.06-1.13,3.79-7.21-7.59-11.76-2.28,5.31,8,12.51,8.35S522.94,374.41,522.94,374.41Z"
            fill="url(#a0bd59cc-cb4c-4b47-aee4-e19b83c7662a)"
          />
          <path
            d="M509.69,378.66c-1.42-.52,4.15-1.64,8.77-4.41s4-6.43,1.89-8.4-9.89-2.15-15.08,6.53a1.71,1.71,0,0,1-1.55.83c-.62,0-.72-1.7-.72-1.7s1.18-13.37-4.58-13S492,365,494.31,369.9s1.51,7-2.36,3.18-4.21-9.58-10.29-6.12,2.3,9.29,8.95,12.08S511.12,379.17,509.69,378.66Z"
            fill="url(#aa784408-2550-434a-99ff-d8cb131c265f)"
          />
        </g>
      </g> */}
      {/* <g>
        <ellipse
          cx="422.52"
          cy="388.52"
          rx="18.39"
          ry="3.85"
          fill="url(#b6be1f12-19da-4f17-b067-a4abf87206c9)"
        />
        <g>
          <path
            d="M449.9,386.05a3.83,3.83,0,0,0,1.19-7.2,13.83,13.83,0,0,0-11.39-.72c11.21-4.8,16.95-10.68,9.61-16-5.87-4.27-14.95,11.21-17.08,11.21s1.07-6.41,5.87-12.28,4.27-10.68.53-12.28-10.14,1.07-11.74,17.62c0-2.67,1.07-19.22-3.2-17.62s-7.48,10.68-.54,20.29c-4.27,1.6-3.73-2.67-3.73-2.67s-2.14-16-9.61-12.81-5.34,11.74,0,17.08,5.34,8.54-1.6,5.33-10.14-10.67-16.55-3.2,11.21,16.55,21.35,17.08C420.36,390.26,439.78,387.56,449.9,386.05Z"
            fill="url(#b744fe62-4945-4b14-9c8d-ecdd72017ebe)"
          />
          <path
            d="M443.44,384.6c.38-3-5.3-6.06-9.85-2.27,6.82-6.07,8.34-11,4.93-11s-11,6.45-12.52,6.45,3.35-2.95,6.76-7.12,1.59-7.41-1.07-8.54c-2.48-1.07-10,1.32-12,11.25a1.74,1.74,0,0,1-1.18,1.31c-.59.19-1.26-1.35-1.26-1.35s-3.41-13-8.72-10.72-3.79,8.34,0,12.13,3.79,6.07-1.14,3.8-7.2-7.59-11.75-2.28,5.31,8,12.51,8.34S443.44,384.6,443.44,384.6Z"
            fill="url(#abd842f3-19ec-4d33-9052-493b06e42c99)"
          />
          <path
            d="M430.2,388.86c-1.43-.52,4.15-1.65,8.77-4.41s4-6.43,1.89-8.4-9.9-2.15-15.08,6.53a1.75,1.75,0,0,1-1.56.83c-.61,0-.72-1.7-.72-1.7s1.19-13.37-4.58-13-6.39,6.56-4.11,11.41,1.52,7-2.35,3.19-4.21-9.58-10.29-6.13,2.3,9.3,8.95,12.09S431.63,389.37,430.2,388.86Z"
            fill="url(#b8888181-df7a-48af-b71c-3cd19fa2bb19)"
          />
        </g>
      </g> */}
    </g>
  );
};

export default Decor3;
